import React from 'react';
import { useShortcutContext } from './ShortcutProvider';

/**
 * Pushes `scope` onto the provider's scope stack while the caller is
 * mounted, popping it on unmount. A page pushes its base scope for as long
 * as it is on screen; a dialog pushes its own on top while it is open,
 * suspending every scope below it until it closes.
 */
export const useShortcutScope = (scope: string): void => {
    const { pushScope, popScope } = useShortcutContext();

    React.useEffect(() => {
        pushScope(scope);
        return () => popScope(scope);
    }, [scope, pushScope, popScope]);
};
